import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle } from '@material-ui/core';
import { Button } from '@ipc/ipc-components';
import { StyledModalForm } from './formModal.styles';

function ConfirmationDialog(props) {
  const {
    isOpen,
    onClose,
    onSubmit,
    cancelButtonText,
    submitButtonText,
    confirmationTitle,
  } = props;
  return (
    <Dialog onClose={onClose} aria-labelledby="simple-dialog-title" open={isOpen}>
      <DialogTitle id="simple-dialog-title">{confirmationTitle}</DialogTitle>
      <StyledModalForm>
        <div className="after-box">
          <Button className="cancel" onClick={onClose}>{cancelButtonText}</Button>
          <Button
            className="primary-button-false action"
            onClick={onSubmit}
          >
            {submitButtonText}
          </Button>
        </div>
      </StyledModalForm>
    </Dialog>
  );
}

ConfirmationDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  cancelButtonText: PropTypes.string,
  submitButtonText: PropTypes.string,
  confirmationTitle: PropTypes.string,
};

ConfirmationDialog.defaultProps = {
  isOpen: false,
  cancelButtonText: 'Cancel',
  submitButtonText: 'Submit',
};

export default ConfirmationDialog;
